<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='个人信息'></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">用户名：</label>
            <div class="col-lg-3">
              <el-form-item prop="username" :rules="{required: true, message: '用户名不能为空', trigger: 'blur'}">
                <el-input v-model="form.username"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">姓名：</label>
            <div class="col-lg-3">
              <el-form-item prop="truename" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
                <el-input v-model="form.truename"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">性别：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-select v-model="form.sex">
                  <el-option v-for="item in sexoptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">证件号：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-input v-model="form.cardnum"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">生日：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-date-picker v-model="form.birthday" type="date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">手机号：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-input v-model="form.tel"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">专业：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.spid" :dictid="this.$utils.DictEnum.specialty"></FormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">学历：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.eduid" :dictid="this.$utils.DictEnum.edu"></FormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">学位：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.degid" :dictid="this.$utils.DictEnum.deg"></FormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">单位：</label>
            <div class="col-lg-3">
                <el-form-item prop="hosid" :rules="{required: true, message: '单位不能为空', trigger: 'blur'}">
                  <FormHospitalSelect v-model="form.hosid"></FormHospitalSelect>
                </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">科室：</label>
            <div class="col-lg-3">
                <el-form-item prop="secid" :rules="{required: true, message: '科室不能为空', trigger: 'blur'}">
                  <FormDictItemSelect v-model="form.secid" :dictid="this.$utils.DictEnum.section"></FormDictItemSelect>
                </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">工号：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-input v-model="form.jobnum"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">工作时间：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-date-picker v-model="form.workdate" type="date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">工龄：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-input v-model="form.worklengh"></el-input>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">职称：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.usertitle" :dictid="this.$utils.DictEnum.title"></FormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-1 col-form-label">级别：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.userlevel" :dictid="this.$utils.DictEnum.userlevel"></FormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">类型：</label>
            <div class="col-lg-3">
              <el-form-item>
                <FormDictItemSelect v-model="form.usertype" :dictid="this.$utils.DictEnum.usertype"></FormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-lg-1 col-form-label">Email：</label>
            <div class="col-lg-3">
              <el-form-item>
                <el-input v-model="form.userextension3"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12" style="text-align: center;">
                  <SaveButton :url="saveUrl" back="0"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IndexUserEdit',
    data() {
      return {
        form: {
          id: '',
          username: '',
          truename: '',
          sex: '',
          jobnum: '',
          hosid: '',
          secid: '',
          cardnum: '',
          birthday: '',
          tel: '',
          spid: '',
          degid: '',
          eduid: '',
          workdate: '',
          worklengh: '',
          usertitle: '',
          userlevel: '',
          usertype: '',
          userextension3: '',
          token: ''
        },
        statusoptions: [{
          label: '启用',
          value: 1
        }, {
          label: '停用',
          value: 0
        }],
        sexoptions: [{
          label: '男',
          value: 1
        }, {
          label: '女',
          value: 0
        }],
        saveUrl: this.$utils.Url.system + '/systemapi/user/update'
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      var that = this
      var args = {
        token: this.form.token,
        id: this.form.id
      }
      // 加载用户信息
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/user/info', args, function (data) {
        console.log(data.Data)
        that.form.username = data.Data.UserName
        that.form.truename = data.Data.TrueName
        that.form.sex = data.Data.Sex
        that.form.jobnum = data.Data.JobNum
        that.form.hosid = data.Data.HosID
        that.form.secid = data.Data.SecID
        that.form.cardnum = data.Data.CardNum
        that.form.birthday = data.Data.Birthday
        that.form.tel = data.Data.Tel
        that.form.spid = data.Data.SpID
        that.form.degid = data.Data.DegID
        that.form.eduid = data.Data.EduID
        that.form.workdate = data.Data.WorkDate
        that.form.worklengh = data.Data.WorkLength
        that.form.usertitle = data.Data.UserTitle
        that.form.userlevel = data.Data.UserLevel
        that.form.usertype = data.Data.UserType
        that.form.roleid = data.Data.RoleID
        that.form.userextension3 = data.Data.UserExtension3
      }, null, null)
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
</style>
